import React from 'react';
import ReactDOM from 'react-dom/client';
import RouteFile from './routeFile.js';
// import Countdown from './Pages/comingSoon.js';
import reportWebVitals from './reportWebVitals';
import './output.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <RouteFile />
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
